import {useTheme} from '@mui/material'

export function useThemePalette() {
  const theme = useTheme()
  return theme.palette
}
